import React, { useState, useEffect, useRef} from 'react';
import '../css/PhoneCallsArea.css';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TransitionAlert from './TransitionAlert.js';
import { TTPDateTimePicker } from './TTPDateTimePicker';
import { useSelector, shallowEqual} from 'react-redux';

//import parse from 'html-react-parser'

import {APIAddPhoneCall} from '../APIS/wupuapAPI.js'
import {getNowMySQL} from '../globals'


export default function MakePhoneCall(props) {
    //const [data,setData] = useState(props.data??null)
    //const [opennote, setOpenNote] = useState(false)
    //const [phonecalls, setPhoneCalls] = useState([])
    //const [notetitle,setNoteTitle] = useState("");
    //const [note,setNote] = useState('')
    const [openalert, setOpenAlert] = useState(false)
    const [alertmsg, setAlertMsg] = useState("")
    const [openphonecall,setOpenPhoneCall] = useState(props.open)
    //const [selnote,setSelNote]=useState(-1)
    const [callduration, setCallDuration] = useState(0)
    const [callbackdate,updateCallBkDate] = useState(null)
    const [phoneTextRef, setPhoneTextRef] = useState(null)
    const [callOutcome, setCallOutcome] = useState("")
    //const [dialopen, setDialopen] = useState(false)
    const [timerid,setTimerid] = useState(null)
    const auth = useSelector(state => state.auth, shallowEqual)

    const phoneNumRef = useRef(props.phone);
    const telRef = useRef(null);
    let calldurationstr=useRef("00:00:00")

    useEffect(()=>{
      //setDialopen(props.open??false)
      console.log(`useEffect ${typeof telRef?.current?.click} `, telRef?.current)
      if(props.open && props.phone > "" && (typeof props.donotdial === 'undefined' || props.donotdial===false) ) {
        console.log(`CLICKING to Dial ${props.donotdial}`)
        window.location.href = `tel:${props.phone}`
      }
    },[props.phone, props.open, props.donotdial])

    useEffect(() => {
      const interval = setInterval(() => {
        setCallDuration((prev) => {    
            const seconds = prev+1;
            const minutes = parseInt(seconds/60);
            const hours = parseInt(seconds/3600);
            const remseconds =  seconds -  (hours *3600 ) - (minutes * 60)

            if(seconds%5===0) {
              calldurationstr.current = `${hours.toString().padStart(2,"0")}:${minutes.toString().padStart(2,"0")}:${remseconds.toString().padStart(2,"0")}`
            }
            return (seconds)
          }
        );
      }, 1000);
      setTimerid(interval)
      return () => {
        console.log(`clearing interval`);
        clearInterval(interval);
      };
    }, [props.starttime ]);

    useEffect(()=> {
        setOpenPhoneCall(props.open)
    },[props.data, auth.token, props.open]);




    const handleCallOutcome = (event) => {
      setCallOutcome(event.target.value);
    };

    const OpenAlert = (msg) => {
        setAlertMsg(msg)
        setOpenAlert(true)
        return;
    }

    const handlePhoneTextChange = (e) => {
      setPhoneTextRef(e.target.value)
    }

    const handleAddPhoneCall = async (e) => {
        //console.log(`id set to ${data._id}`)
        const phoneno = phoneNumRef?.current;


        if(callOutcome.trim()===""){
          OpenAlert(`Error You Must Enter a Call Outcome before you can Add a New Note.`)
          return;
        }
        if((phoneTextRef??"").toString().trim()===""){
          OpenAlert(`Error You Must Enter Some Note Text before you can Add a New Note.`)
          return
        }

        const datetime_added = getNowMySQL();
        console.log(`handleAddPhoneCall:`, props.data)
        //(prevNotes => [...prevNotes, {note, title: notetitle, added_by: auth.name, dateadded: datetime_added, datetime_added}])
        const ret = await APIAddPhoneCall({
          number_dialled: props.phone,
          token: auth.token,
          company_id: props.data["Company Number"]??"",
          ttp_lead_id: props.data.uid,
          note:phoneTextRef,
          added_by: auth.name,
          call_outcome: callOutcome,
          datetime_dialled: datetime_added,
          call_duration: callduration,
          callback_set: callbackdate
        })

        //console.log(ret)
        if(!ret.status)
          OpenAlert(`Error adding note ${ret.err}`)
        else{
          setOpenPhoneCall(false)
          setPhoneTextRef(null);
          if(typeof props.onClose === 'function')
            props.onClose()
        }
        clearInterval(timerid);
        setTimerid(null)
    }

    const cancelPhoneCall = () => {
        if(typeof props.onClose === 'function')
          props.onClose()
        setOpenPhoneCall(false)
        setPhoneTextRef(null);
        clearInterval(timerid);
        setTimerid(null)
    }
    return (
        <React.Fragment>
            <Dialog
                open={openphonecall}
                onClose={() => setOpenPhoneCall(false)}
                maxWidth='xxl'
                PaperProps={{component: 'form'}}
                style={{minWidth: '400px!important'}}
            >
                <DialogTitle>Add New Phone Call</DialogTitle>
                <DialogContent>
                <TextField
                    label='Phone Number'
                    id='notetitle'
                    name='notetitle'
                    type='text'
                    placeholder='Phone Number Dialed'
                    defaultValue={props.phone}
                    variant="standard"
                    sx={{fontSize: '10pt', marginBottom:'15px', width: '300px'}}
                    readOnly={true}
                />
                <button><a href={`tel:${props.phone}`} ref={telRef} style={{display: 'inline', fontSize: '10pt'}} >Click To Dial</a></button>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Call Outcome</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={callOutcome}
                    label="Select Call Outcome"
                    onChange={handleCallOutcome}
                  >
                    <MenuItem value="">Select A Call Outcome</MenuItem>
                    <MenuItem value="NOANS">No Answer</MenuItem>
                    <MenuItem value="ANSPHONE">Answer Phone</MenuItem>
                    <MenuItem value="ENGAGED">Engaged</MenuItem>
                    <MenuItem value="NNR">Number Not Recognised</MenuItem>
                    <MenuItem value="DEADNUM">Dead Number</MenuItem>
                    <MenuItem value="DNC">DO NOT CONTACT</MenuItem>
                    <MenuItem value="OVERSEAS">Overseas</MenuItem>
                    <MenuItem value="CLBCK">Call Back</MenuItem>
                    <MenuItem value="COMPLETE">Call Completed</MenuItem>
                  </Select><br/>
                </FormControl>
                Schedule a Call Back&nbsp;&nbsp;
                <TTPDateTimePicker
                  label="Call back date / time"
                  onChange={updateCallBkDate}
                />
                <TextareaAutosize multiline="true" className='phones' id='notes' placeholder='Enter Notes Here' minRows={8} maxRows={20} rows={8} onChange={handlePhoneTextChange} style={{width: '600px'}} />
                <TransitionAlert open={openalert} Close={setOpenAlert} message={alertmsg} />
                </DialogContent>
                <DialogActions>
                <span style={{justifySelf: 'self-start', fontSize: '8pt'}}>Call Duration {calldurationstr.current} </span>
                <Button size='small' variat='outline'  onClick={cancelPhoneCall}>Cancel Call</Button>
                <Button size='small' variat='outline' onClick={handleAddPhoneCall}>Add Call Outcomes</Button>
                </DialogActions>

            </Dialog>
    </React.Fragment>

    )
}